import * as React from 'react'
import {
  Box,
  Fab,
  CircularProgress,
  IconButton,
  Tooltip,
} from '@mui/material'
import { Check, Save, DeleteOutline } from '@mui/icons-material'
import { green, red } from '@mui/material/colors'
import { updatePseudonymById } from '../../../services'

const PseudonymActions = ({ params, rowId, setRowId, onRequestDelete }) => {
  const [loading, setLoading] = React.useState(false)
  const [success, setSuccess] = React.useState(false)

  const TOKEN = `Bearer ${window.localStorage.getItem('ArbolEc_token')}`

  const isSuccessfulResponse = result => {
    if (!result) return false
    const hasExplicitFailure =
      result?.update === false ||
      result?.updated === false ||
      result?.success === false ||
      result?.deleted === false ||
      Boolean(result?.error) ||
      Boolean(result?.errors)
    return !hasExplicitFailure
  }

  const normalizeValidationStatus = value => {
    if (!value) return null
    const normalized = String(value).trim().toLowerCase()
    if (normalized === 'verificado') return 'verificado'
    if (normalized === 'pendiente') return 'pendiente'
    return normalized
  }

  const handleSubmit = () => {
    setLoading(true)
    const { id, nombre_comun, idEspecie, habilitado, estado_validacion } = params.row
    const normalizedStatus = normalizeValidationStatus(estado_validacion)
    const data = { nombre_comun, idEspecie, habilitado }
    if (normalizedStatus) data.estado_validacion = normalizedStatus
    setTimeout(async () => {
      const result = await updatePseudonymById(data, TOKEN, id)
      if (isSuccessfulResponse(result)) {
        setSuccess(true)
        setRowId(null)
      }
      setLoading(false)
    }, 1000)
  }

  React.useEffect(() => {
    if (rowId === params.id && success) setSuccess(false)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rowId])

  return (
    <Box sx={{ m: 1, position: 'relative', display: 'flex', gap: 0.5, alignItems: 'center' }}>
      {success ? (
        <Fab color="primary" sx={{ width: 40, height: 40, bgcolor: green[500], '&:hover': { bgcolor: green[700] } }}>
          <Check />
        </Fab>
      ) : (
        <Fab
          color="primary"
          sx={{ width: 40, height: 40 }}
          disabled={params.id !== rowId || loading}
          onClick={handleSubmit}>
          <Save />
        </Fab>
      )}
      {loading && (
        <CircularProgress
          size={52}
          sx={{ color: green[500], position: 'absolute', top: -6, left: -6, zIndex: 1 }}
        />
      )}

      <Tooltip title="Eliminar pseudónimo">
        <IconButton
          size="small"
          onClick={() => onRequestDelete(params.row)}
          sx={{ color: red[600], '&:hover': { bgcolor: red[50] } }}>
          <DeleteOutline fontSize="small" />
        </IconButton>
      </Tooltip>
    </Box>
  )
}

export default PseudonymActions
